export const WAREHOUSES_WITH_RELAXED_STORAGE_DIMENSIONS = ["DFW1RS", "EWR1RS", "STO_TST_LOG"];
export const OVERRIDE_STORAGE_INBOUND_MAX_CASE_LONGEST_IN = 250;
export const OVERRIDE_STORAGE_INBOUND_MAX_CASE_MIDDLE_IN = 100;
export const OVERRIDE_STORAGE_INBOUND_MAX_CASE_SHORTEST_IN = 100;
